import {connect} from 'react-redux'
import {markNotificationAsRead, selectNotification, selectedNotification} from '../../state'
import {NotificationItem} from "./notification-item";
import {userId} from "../../../../user-management";
import {textToSpeechEnabled} from "../../../../app"

const mapStateToProps = (state) => ({
  notification: selectedNotification(state),
  userId: userId(state),
  textToSpeechEnabled: textToSpeechEnabled(state),
})

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(selectNotification(null)),
  markAsRead: (notificationId, userId) => dispatch(markNotificationAsRead(notificationId, userId))
})

export const NotificationItemConnected = connect(mapStateToProps, mapDispatchToProps)(NotificationItem)